import { Region } from "@/api/studio/data/types/region.type";
import { SceneMetric } from "../stores/use-reports-scene-store";

/**
 * Get the metric value from a region based on the scene metric type
 *
 * @param region - The region object containing vis, pop, soa, pow values
 * @param metric - The scene metric type (vis, pop, soa, pow)
 * @returns The metric value, or 0 if not found
 */
export const getSceneMetricValue = (region: Region, metric: SceneMetric): number => {
  switch (metric) {
    case "vis":
      return region.vis ?? 0;
    case "pop":
      return region.pop ?? 0;
    case "soa":
      return region.soa ?? 0;
    case "pow":
      return region.pow ?? 0;
    default:
      return region.vis ?? 0;
  }
};

/**
 * Format a metric value for display based on the scene metric type
 *
 * @param value - The numeric metric value
 * @param metric - The scene metric type (vis, pop, soa, pow)
 * @returns Formatted string (e.g., "100%" for vis/pop/soa, "1.50x" for pow)
 */
export const formatSceneMetricValue = (value: number, metric: SceneMetric): string => {
  if (metric === "pow") {
    return `${value.toFixed(2)}x`;
  }
  return `${Math.round(value)}%`;
};
